import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vue3PersianDatetimePicker from 'vue3-persian-datetime-picker'

import "./style/main.scss"
import "@coreui/coreui"
import 'nprogress/nprogress.css'

import './mathjax.config'
import 'mathjax/es5/tex-chtml'
import VueSocketIO from './socket';

createApp(App)
    .use(router)
    .use(store)
    .use(VueSocketIO)
    .use(Vue3PersianDatetimePicker, {
        'name': 'date-picker',
        props: {
            format: "YYYY-MM-DD",
            displayFormat: 'jYYYY/jMM/jDD',
            inputClass: 'form-control',
            useRouter: true,
        }
    })
    .mount('#app')
